import React, { useContext } from "react";
import AsyncSelect from "react-select/async";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { globalServices } from "../../../../Services/global.service";
import { roles } from "../../../../Config/Roles";
import { AuthContext } from "../../../../Contexts/AuthContext";

const ClientInput = ({ control, setSearch, search, setStores, setValue }) => {
  const { t: translator } = useTranslation();
  const { userId, roleId } = useContext(AuthContext);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenantsRobno(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));

        if (Number(roleId) === roles.owner && result?.length === 1) {
          const tenant = result.find((x) => x.id === search.tenantId) || null;
          setValue("tenantId", tenant);
          handleOnChange(tenant ? [tenant] : null);
        }
        return result;
      })
      .catch((err) => err);
  };

  console.log("SEARCH BEFORE CLEARING TENANT: ", search);
  const handleOnChange = (event) => {
    if (!event) return;
    if (event?.[1]?.action === "clear") {
      setSearch({ ...search, tenantId: 0 });
      setStores([]);
    } else {
      setSearch({ ...search, tenantId: event[0].id });
      globalServices
        .getStoresByTenantId(event[0].id)
        .then((res) => {
          setStores(res.data);
          setValue("storeId", null);
        })
        .catch((err) => console.log(err));
    }
    return event[0];
  };
  return (
    <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
      <label htmlFor="ddlTenants">
        {translator("InvIssReport-Filters-Tenants")}
      </label>
      <Controller
        name="tenantId"
        as={AsyncSelect}
        control={control}
        rules={{
          validate: function (value) {
            if (!value) return false;
            return value.value === 0 ? false : true;
          },
        }}
        onChange={handleOnChange}
        isClearable
        defaultOptions={true}
        loadOptions={promiseOptions}
        placeholder={translator("Select-Tenant")}
      />
    </div>
  );
};

export default ClientInput;
